import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { ApiTokensListResponseData, DataResponse } from "schema"

type AuthResponse = DataResponse<ApiTokensListResponseData>

export const apiTokensQuery = () => {
  return queryOptions({
    queryKey: ["apiTokens"],
    queryFn: async () => {
      const { data } = await axios.get<AuthResponse>(`/apiTokens`)
      return data.data
    },
  })
}
